module.exports = __webpack_public_path__ + "img/ins_step3_success.84af0673.svg";